import React from "react";
import TagMovingAverageHeader from "../TagMovingAverageHeader";
import ISXUtils from "services/Utils";

export const getTagInfoForStack = (
  stack,
  filterTagsOptions,
  showDerivedTags
) => {
  const derivedTagSeparator = "|";
  const localComputeIndicator = "lc";
  const movingAverage = "ma";
  const windowSpec = "10";

  const attributes = ISXUtils.filterStackTags(stack, filterTagsOptions);
  const tagInfo = Object.fromEntries(
    attributes.map((attr) => [
      attr,
      { name: ISXUtils.getTagName(attr, stack.data_config), avg: false },
    ])
  );
  if (showDerivedTags !== false) {
    attributes.forEach((attr) => {
      const derivedTag =
        derivedTagSeparator +
        movingAverage +
        "-" +
        (
          stack["data_config"][attr]?.numeric?.ema?.window ||
          parseInt(windowSpec)
        ).toString() +
        "sm-" +
        localComputeIndicator;
      tagInfo[attr + derivedTag] = {
        name: tagInfo[attr].name + " (Avg)",
        avg: true,
      };
    });
  }
  //add other reserved tags
  tagInfo['isxreserved|alerts'] = {'name':'Alerts',avg:false}
  return tagInfo;
};

export const getSortedTagNamesFromInfo = (tagInfo) =>
  Object.entries(tagInfo)
    .sort((a, b) =>
      a[1].avg < b[1].avg
        ? -1
        : a[1].avg > b[1].avg
        ? 1
        : ISXUtils.strcasecmp(a[1].name, b[1].name)
    )
    .map((a) => a[0]);

export const tagsRenderGroup = (params) => [
  params.group ? <TagMovingAverageHeader key={params.key} /> : params.group,
  params.children,
];
